import { OrderStatus } from "../orders/orders";

export interface CustomerType {
	id: string;
	firstName: string;
	lastName: string;
	email: string;
	phoneNumber?: string;
	address?: string;
	addressProofUrl?: string;
	state?: string;
	city?: string;
	companyName?: string;
	jobTitle?: string;
	joinedAt?: string;
	employmentType?: string;
	employmentContractUrl?: string;
	linkedInUrl?: string;
	photoUrl?: string;
	idCardType?: string;
	idCardNumber?: string;
	meterNumber?: string;
	electricityDistributionCompany?: string;
	bvn?: string;
	monoVerified: boolean;
	bvnVerifyDetails?: BvnVerifyDetails;
	internationalPassportVerificationDetails?: InternationalPassportVerificationDetails;
	ninVerificationDetails?: NinVerificationDetails;
	addressVerificationDetails?: AddressVerificationDetails;
}

export interface CreditEngineScore {
	category: CreditEngineScoreType;
	score: number;
	serviceableLoanAmount: number;
	numberOfClosedLoans: number;
	numberOfPerformingLoans: number;
}

export type CreditEngineScoreType =
	| "No Credit History"
	| "No Income Details"
	| "Closed with Performing Loans"
	| "No Disbursed Date Reported"
	| "Very High Risk"
	| "High Risk"
	| "Moderate Risk"
	| "Low Risk";
export interface BvnVerifyDetails {
	id: string;
	firstName: string;
	lastName: string;
	middleName: string;
	dob: string;
	phoneNumber: string;
	phoneNumber2: string;
	email: string;
	gender: string;
	stateOfOrigin: string;
	bvn: string;
	nin: string;
	registrationDate: string;
	lgaOfOrigin: string;
	lgaOfResidence: string;
	maritialStatus: string;
	watchListed: boolean;
	photoId: string;
}

export interface CustomerDashboardModel {
	walletBalance: number;
	bankName: string;
	accountNumber: string;
	fullName: string;
	bnplOffer: BPNLOFFER;
	bnplOfferId: string;
	amountFinanced: number;
	totalOutstanding: number;
	amountDue: number;
	paymentDueDate: string;
}

export enum BPNLOFFER {
	NEW_PACKAGE_OFFER = "New package offer",
	NO_ACTIVE_PACKAGE = "No active package",
	ACTIVE = "Active",
	TRANSACTION_IN_PROGRESS = "Transaction in progress",
}
export interface InternationalPassportVerificationDetails {
	dob: string;
	documentType: string;
	expiryDate: string;
	firstName: string;
	gender: string;
	issuedAt: string;
	issuedDate: string;
	lastName: string;
	middleName: string;
	mobile: string;
	number: string;
	photo: string;
	referenceId: string;
	signature: string;
}

export interface NinVerificationDetails {
	birthCountry?: string;
	birthDate?: string;
	birthLGA?: string;
	birthState?: string;
	educationalLevel?: string;
	email?: string;
	employmentStatus?: string;
	firstName?: string;
	gender?: string;
	height?: string;
	maritalStatus?: string;
	middleName?: string;
	nin?: string;
	nokAddress1?: string;
	nokAddress2?: string;
	nokFirstName?: string;
	nokLga?: string;
	nokMiddleName?: string;
	nokPostalCode?: string;
	nokState?: string;
	nokSurname?: string;
	nokTown?: string;
	oSpokenLang?: string;
	pFirstName?: string;
	photo?: string;
	pMiddleName?: string;
	profession?: string;
	pSurname?: string;
	religion?: string;
	residenceAddress?: string;
	residenceLga?: string;
	residenceState?: string;
	residenceTown?: string;
	residenceStatus?: string;
	selfOriginLga?: string;
	selfOriginPlace?: string;
	selfOriginState?: string;
	signature?: string;
	spokenLanguage?: string;
	surname?: string;
	telephoneNo?: string;
	title?: string;
	userId?: string;
	vNin?: string;
	centralId?: string;
	trackingId?: string;
}

export interface AddressVerificationDetails {
	verified: boolean;
	houseAddress: string;
	houseOwner: string;
	confidenceLevel: number;
	discoCode: string;
}

export interface ProviderCustomerOrder {
	id: string;
	customerName: string;
	customerPhoneNumber: string;
	productName: string;
	paymentDate?: Date;
	status: OrderStatus;
	statusChanged: string;
	customerAddress: string;
	amountPaidFor: number;
	productDescription: string;
	roofType?: string;
	roofTypeImage?: string;
	buildingType: string;
	numberOfFloors?: number;
}

export interface CustomerQuery {
	page?: number;
	pageSize?: number;
	search?: string;
}

export interface AdminCustomerModel {
	id: string;
	firstName: string;
	lastName: string;
	phoneNumber: string;
	email: string;
	dateRegistered: string;
}

export interface AdmimCustomerDetailsModel {
	firstName: string;
	lastName: string;
	dateOfBirth: string;
	email: string;
	phoneNumber: string;
	accountNumber: string;
	amountPaid: number;
	outstandingAmount: number;
	upcomingPayment: number;
	loanStatus: string;
}

export type CustomerVerificationStatus = "Pending" | "Success" | "Failed" | "Cancelled";

export interface CustomerPaystackCard {
    id: string;
    status: CustomerVerificationStatus;
    bin?: string;
    last4?: string;
    expMonth?: string;
    expYear?: string;
    channel?: string;
    cardType?: string;
    bank?: string;
    countryCode?: string;
    brand?: string;
    reusable?: boolean;
    signature?: string;
    accountName?: string;
}

export interface CustomerPaymentOptions{
	virtualWalletConnected: boolean;
	paystackConnected: boolean;
}